import { Budget } from "../types";
import { BudgetRecipientEnum } from "../../budgetsForm/createAndEdit/types";
import { UserProfileEnum, getBudgetsRoute, getBudgetsKanbanRoute } from "../../../enums/profile";

export const getStatusStyles = (status: Budget["status"]) => {
  switch (status) {
    case "aceito":
      return {
        cardBg: "bg-[#FFFFFF]",
        border: "",
        buttonBg: "",
        buttonText: "text-gray-900",
        buttonHover: "hover:opacity-90",
      };
    case "contraproposta":
      return {
        cardBg: "bg-[#FFFFFF]",
        border: "",
        buttonBg: "",
        buttonText: "text-gray-900",
        buttonHover: "hover:opacity-90",
      };
    case "recusado":
      return {
        cardBg: "bg-[#FFFFFF]",
        border: "border-red-200",
        buttonBg: "bg-red-500",
        buttonText: "text-white",
        buttonHover: "hover:bg-red-600",
      };
    case "enviado":
      return {
        cardBg: "bg-[#FFFFFF]",
        border: "",
        buttonBg: "",
        buttonText: "text-gray-900",
        buttonHover: "hover:opacity-90",
      };
    case "alterado":
      return {
        cardBg: "bg-[#FFFFFF]",
        border: "",
        buttonBg: "bg-gray-600",
        buttonText: "text-white",
        buttonHover: "hover:bg-gray-700",
      };
    default:
      return {
        cardBg: "bg-[#FFFFFF]",
        border: "border-gray-200",
        buttonBg: "bg-gray-400",
        buttonText: "text-gray-700",
        buttonHover: "hover:bg-gray-500",
      };
  }
};

export const getStatusButtonText = (budget: Budget): string => {
  switch (budget.status) {
    case "aceito":
      return budget.recipient === "Volks|total"
        ? "Aceito pelo fabricante"
        : "Aceito pelo cliente";
    case "contraproposta":
      return "Contraproposta";
    case "recusado":
      return "Recusado";
    case "enviado":
      return "Enviado";
    case "alterado":
      return "Alterado";
    default:
      return budget.status.charAt(0).toUpperCase() + budget.status.slice(1);
  }
};

export const getBorderColor = (
  status: Budget["status"]
): string | undefined => {
  switch (status) {
    case "aceito":
      return "#5CB85C";
    case "contraproposta":
      return "#FF8E3C";
    case "enviado":
      return "#F9FAFB";
    case "alterado":
      return "#6B7280";
    case "recusado":
      return "#EF4444";
    default:
      return undefined;
  }
};

export const getButtonBackgroundColor = (
  status: Budget["status"]
): string | undefined => {
  switch (status) {
    case "aceito":
      return "#ABEFC6";
    case "contraproposta":
      return "#F9DBAF";
    case "enviado":
      return "#E4E7EC";
    default:
      return undefined;
  }
};

export const getRouteByProfile = (profile: BudgetRecipientEnum | string | undefined): string => {
  if (!profile) {
    return "";
  }
  
  if (profile === BudgetRecipientEnum.TOWER) {
    return getBudgetsRoute(UserProfileEnum.CONTROL_TOWER);
  }
  
  if (profile === BudgetRecipientEnum.CONSULTANT) {
    return getBudgetsRoute(UserProfileEnum.DEALERSHIP);
  }
  
  if (profile === BudgetRecipientEnum.MANAGER) {
    return getBudgetsRoute(UserProfileEnum.FLEET_MANAGER);
  }
  
  return "";
};

export const getKanbanRouteByProfile = (profile: BudgetRecipientEnum | string | undefined): string => {
  if (!profile) {
    return "";
  }

  const profileStr = String(profile).toUpperCase();
  
  if (profileStr === "TOWER" || profileStr === "FACTORY") {
    return getBudgetsKanbanRoute(UserProfileEnum.CONTROL_TOWER);
  }
  
  if (profileStr === "CONSULTANT") {
    return getBudgetsKanbanRoute(UserProfileEnum.DEALERSHIP);
  }
  
  if (profileStr === "MANAGER") {
    return getBudgetsKanbanRoute(UserProfileEnum.FLEET_MANAGER);
  }
  
  return "";
};